// extracted by mini-css-extract-plugin
export default {"controls":"carousel-module__controls___ZojAW","previous":"carousel-module__previous___oay9d","next":"carousel-module__next___PmMba"};